export default {
  postureReport: "Posture Report",
  postureData: "Posture Data",
  postureDataContrast: "Posture Data Contrast",
  postureRiskContrast: "Posture Risk Contrast",
  postureDataTrend: "posture Data Trend",
  postureRiskTrend: "posture Risk Trend",
  postureLogData: "Posture Log Data",
  lateralhead: "Lateral head tilt",
  unevenshoulder: "Uneven shoulders",
  scoliosis: "Scoliosis",
  unevenhip: "Uneven hips",
  xleg: "X-shaped leg",
  oleg: "O-shaped leg",
  roundedshoulder: "Rounded shoulder",
  kneehyperextension: "Knee hyperextension",
  trunkforwardtilt: "Trunk forward tilt",
  trunklateraltilt: "Trunk Lateral Tilt",
  heel: "Heel",
  forwardhead: "Forward head",
  toTheLeft: "(left)",
  toTheRight: "(right)",
  bracketsLeft: "(L)",
  bracketsRight: "(R)",
  bracketsNormal: "(Normal)",
  leg: "Legs",
  legLeft: "Legs(L)",
  legRight: "Legs(R)",
  riskAssessment: "Risk Assessment",
  muscleState: "Muscle State",
  muscleStateDesc: "No abnormal muscle condition found",
  testTime: "Test Time",
  hRisk: "H",
  mRisk: "M",
  lRisk: "L",
  item: "Item",
  degree: "°",
  percent: "%",
  mm: "mm",
  moireImage: "Moire image",
  lAbnormalRisk: "L Risk",
  mAbnormalRisk: "M Risk",
  hAbnormalRisk: "H Risk",
  highRisk: "High Risk",
  riskAnalysis: "Risk Analysis",
  conclusionRecommendation: "Conclusion Recommendation",
  solution: "Solution",
  movePosition: "Click the dot to move the position",
  confirmTheClose: "Have not saved to confirm the close",
  closeInfo: "Changes will not be saved after closing, so if you need to change the data, please click Save Data after canceling",
  share: "Share",
  front: "Front",
  side: "Side",
  back: "Back",
  otherSide: "Other Side",
  points: "Points",
  angle: "angle",
  name: "Name",
  gender: "Gender",
  male: "male",
  female: "female",
  age: "Age",
  year: "years old",
  height: "Height",
  weight: "Weight",
  time: "Time",
  patientId: "Patient ID",
  save: "Save",
  saveModify: "Save Modify",
  print: "Print",
  cancel: "Cancel",
  zoomIn: "Zoom In",
  zoomOut: "Zoom Out",
  ok: "OK",
  return: "Back",
  empty: " ",
  unknown: "unknown",
  succeedToCopy: "Copy successfully",
  succeedToSave: "Save successfully",
  failedToSave: "Save Failed",
  reload: "Reload",
  loading: "loading...",
  toolbox: "Toolbox",
  protractor: "Protractor",
  ruler: "Ruler",
  drag: "Drag",
  mirror: "Mirror",
  crop: "Crop",
  point: "Point",
  vertical: "Vertical Line",
  horizontal: "Horizontal Line",
  verticalAngle: "Vertical Angle",
  horizontalAngle: "Horizontal Angle",
  headForwardDistance: "Head Forward Distance",
  pelvisForwardTilt: "Pelvis Forward Tilt",
  wristHipDistanceLeft: "Wrist to Hip Distance (Left)",
  wristHipDistanceRight: "Wrist to Hip Distance (Right)",
  evaluator: "Evaluator",
  reportDate: "Report Date",
  introduction: "Introduction",
  doctorIntroDefault: "Professional field: Rehabilitation medicine, posture assessment and correction | Years of experience: more than 5 years | Expertise: Sports injury rehabilitation, posture correction, pain management",
  recoveryLog: "Recovery Log",
  returnToReport: "Return to Report",
  showToolbox: "Show Toolbox",
  hideToolbox: "Hide Toolbox",
};
